import logoWhite from "@/assets/brand/TangoNetworks_Horizontal_White.svg";

/**
 * Optional Tango Networks lockup pinned to the top-right of a hero image.
 *
 * Legibility over an unknown photograph is handled three ways at once:
 *  - the white logo variant (never the navy one, which disappears on dark photos),
 *  - a soft dark scrim behind it that fades out, so a bright sky can't swallow it,
 *  - a drop shadow on the mark itself for the in-between cases.
 */
export function HeroBrandLogo({ className = "" }: { className?: string }) {
  return (
    <div className={`pointer-events-none absolute top-4 right-4 md:top-6 md:right-6 z-30 ${className}`}>
      <div className="relative flex items-center justify-center px-4 py-2.5 md:px-5 md:py-3">
        <div
          className="absolute inset-0 rounded-xl bg-[radial-gradient(ellipse_at_center,hsl(var(--primary)/0.55),transparent_75%)] backdrop-blur-[2px]"
          aria-hidden="true"
        />
        <img
          src={logoWhite}
          alt="Tango Networks"
          width={160}
          height={32}
          loading="eager"
          className="relative h-7 md:h-9 w-auto drop-shadow-[0_2px_6px_rgba(0,0,0,0.55)]"
        />
      </div>
    </div>
  );
}
